import { loadAdminUsers, loadRoles } from 'actions/managePermissions'
import { loadMdmUsers, resetFetched } from 'actions/mdm'
import Alert from 'components/Alert'
import Card from 'components/Card'
import AutoCompleteInput from 'components/Form/components/AutoCompleteInput'
import SelectInput from 'components/Form/components/SelectInput'
import { Column, Row } from 'components/Grid'
import Heading from 'components/Heading'
import Modal from 'components/Modal'
import SubmitButton from 'components/SubmitButton'
import { IconCheck, IconCross } from 'icons'
import React, { Component, PropTypes } from 'react'
import * as managePermissions from 'schemas/forms/ManagePermissions'
import styles from './ManagePermissions.scss'

import {
  formInit,
  formReset,
  formSubmit,
  formUpdate,
} from 'actions/forms'

class ManagePermissionsView extends Component {
  static propTypes = {
    completeText: PropTypes.string,
    ctaText: PropTypes.string,
    currentUserId: PropTypes.string,
    data: PropTypes.object,
    description: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
    forms: PropTypes.object.isRequired,
    handleFormSubmit: PropTypes.func,
    handleSubmit: PropTypes.func.isRequired,
    hide: PropTypes.func.isRequired,
    id: PropTypes.string,
    managePermissions: PropTypes.object,
    metaData: PropTypes.object,
    modals: PropTypes.object.isRequired,
    show: PropTypes.bool,
    submittingText: PropTypes.string,
    title: PropTypes.string,
  }

  static defaultProps = {
    data: {},
    ctaText: 'Submit',
    completeText: 'Submitted',
    submittingText: 'Submitting',
    show: false,
  }

  constructor() {
    super()

    this.state = {
      lastQuery: '',
      previousRole: '',
      selectedRole: {},
      showStatusAndRole: false,
      showAlert: false,
    }
  }

  componentWillMount() {
    const formFields = managePermissions.formFields

    const formData = {
      formFields,
      data: this.props.data || null,
    }

    this.props.dispatch(formInit(this.props.id, formData))
    this.props.dispatch(loadRoles(this.props.currentUserId))
  }

  componentWillReceiveProps(nextProps) {
    const modalCreated = this.props.modals.managePermissions
    const modalChanged = modalCreated && nextProps.modals.managePermissions.show !== this.props.modals.managePermissions.show
    const modalNotVisible = modalCreated && !nextProps.modals.managePermissions.show
    const modalVisible = modalCreated && nextProps.modals.managePermissions.show
    if (modalChanged && modalNotVisible) {
      this.props.dispatch(formReset(this.props.id))
    }
  }

  getSuggetionList = () => {
    const form = this.props.forms[this.props.id]
    if (form.username.value.length < 1) {
      return []
    }
    if (form.userType.value === 'add') {
      return this.props.metaData.users.map(user => ({ label: `${user.employeeName} (${user.employeeEmail.split('@')[0]})`, value: user.employeeEmail }))
    }
    // if "edit", filter the mdm user list againt existing admin list
    const adminUsernameList = this.props.managePermissions.adminUsers.map(admin => admin.username)
    return this.props.metaData.users.filter(user => (adminUsernameList.includes(user.employeeEmail.split('@')[0]))).map(user => ({ label: `${user.employeeName} (${user.employeeEmail.split('@')[0]})`, value: user.employeeEmail }))
  }

  getRoleList = () => {
    return this.props.managePermissions.roles.map(role => ({ label: role.roleDisplayName, value: role.roleName }))
  }

  _hide = () => {
    this.props.hide(this.props.id)
    this.resetState()
  }

  _handleSubmit = (e) => {
    e.preventDefault()
    const form = this.props.forms[this.props.id]
    const data = {
      loginname: '',
      status: form.status.value,
      rolename: this.state.selectedRole.roleName,
      adGroupName: this.state.selectedRole.adGroup,
      userEmail: form.username.value.value,
      prevADGroupName: form.userType.value === 'add' ? ''
        : this.props.managePermissions.roles.filter(role => role.roleName === this.state.previousRole)[0].adGroup,
    }

    this.props.dispatch(formSubmit(this.props.id))
    this.props.handleSubmit(data, form.userType.value)
  }

  _handleValidation = (name) => {
    const stateValue = {
      field: name,
      data: {
        focus: false,
      },
    }

    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  _handleFocus = (name) => {
    // Create state value obj
    const stateValue = {
      field: name,
      data: {
        focus: true,
      },
    }

    this.props.dispatch(formUpdate(this.props.id, stateValue))
    this.props.dispatch(resetFetched())
  }

  // Handle Changes on form elements
  _handleChange = (name, value) => {
    /*
      Create state value obj
      Reset error handling (Stops error check on focus changes)
    */
    const stateValue = {
      field: name,
      data: {
        value,
        error: '',
        valid: true,
      },
    }

    // Pass state value and handle state
    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  _handleSelectChange = (name, value, selectedIndex) => {
    /*
      Create state value obj
      Reset error handling (Stops error check on focus changes)
    */
    const stateValue = {
      field: name,
      data: {
        value,
        error: '',
        valid: true,
        selectedIndex,
      },
    }

    // Pass state value and handle state
    this.props.dispatch(formUpdate(this.props.id, stateValue))

    switch (name) {
      case 'userType': {
        // load latest admin user list from BED
        this.props.dispatch(loadAdminUsers(this.props.currentUserId))

        // Reset the rest fields
        this.resetState()

        const form = this.props.forms[this.props.id]

        if (form.username.value !== '') {
          this._handleChange('username', '')
        }
        if (form.status.value !== '') {
          this._handleChange('status', '')
        }
        if (form.role.value !== '') {
          this._handleChange('role', '')
        }

        break
      }
      case 'role':
        this.setState({ selectedRole: this.props.managePermissions.roles.filter(role => (role.roleName === value))[0] })
        break

      default:
        break
    }
  }

  _handleSuggestion = (name, value) => {
    this._handleChange(name, value)

    const val = (typeof value === 'object') ? value.label : value
    clearTimeout(this.timeout)
    if (val.length > 2 && this.state.lastQuery !== val) {
      const userType = this.props.forms[this.props.id].userType.value
      this.timeout = setTimeout(() => {
        this.setState(() => ({ lastQuery: val }))
        this.props.dispatch(loadMdmUsers(val, this.props.currentUserId, false, (userType === 'add')))
      }, 400)
    }
  }

  _handleAfterClick = (name, value) => {
    this._handleChange(name, value)

    const userType = this.props.forms[this.props.id].userType.value

    // check if user already exists in admin list when "add"
    if (userType === 'add') {
      if (this.props.managePermissions.adminUsers.filter(adminUser => `${adminUser.username}` === value.value.split('@')[0]).length > 0) { // duplicate with existing admin user
        this.setState({ showAlert: true })
      } else { // valid
        this.setState({
          showStatusAndRole: true,
          showAlert: false,
        })
      }
    } else { // "eidt"
      const selectedAdminUser = this.props.managePermissions.adminUsers.filter(admin => `${admin.username}` === value.value.split('@')[0])
      if (selectedAdminUser.length > 0) {
        this._handleSelectChange('status', selectedAdminUser[0].status)
        this._handleSelectChange('role', selectedAdminUser[0].rolename)
        this.setState({
          showStatusAndRole: true,
          previousRole: selectedAdminUser[0].rolename,
        })
      }
    }
  }

  _schema = () => {
    const obj = {}
    managePermissions.formFields.forEach((field) => {
      obj[field.name] = field
    })
    return obj
  }

  resetState = () => {
    this.setState({
      lastQuery: '',
      previousRole: '',
      selectedRole: {},
      showStatusAndRole: false,
      showAlert: false,
    })
  }

  canSubmit = () => {
    const form = this.props.forms[this.props.id]
    return form.userType.value && form.username.value && form.status.value && form.role.value
  }

  renderAdminCentreAccess = (label, hasAccess) => {
    return (
      <div className={styles.item} key={label.trim()}>
        <Column base={9} layout={12}>
          {label}
        </Column>
        <Column base={3} layout={12}>
          {hasAccess ? <IconCheck className={styles.icon} /> : <IconCross className={styles.crossIcon} />}
        </Column>
      </div>
    )
  }

  renderAdminCentreAccessHeader = () => {
    return (
      <div className={styles.accessHeader}>
        <Column base={9} layout={12}>
          <span className={styles.accessHeaderFirstColumn}>Admin centre</span>
        </Column>
        <Column base={3} layout={12}>
          Actions
        </Column>
      </div>
    )
  }

  renderPartnerPagesAccess = (label, hasViewAccess, hasEditAccess) => {
    return (
      <div className={styles.item} key={label.trim()}>
        <Column base={8} layout={12}>
          {label}
        </Column>
        <Column base={2} layout={12}>
          {hasViewAccess ? <IconCheck className={styles.icon} /> : <IconCross className={styles.crossIcon} />}
        </Column>
        <Column base={2} layout={12}>
          {hasEditAccess ? <IconCheck className={styles.icon} /> : <IconCross className={styles.crossIcon} />}
        </Column>
      </div>
    )
  }

  renderPartnerPagesAccessHeader = () => {
    return (
      <div className={styles.accessHeader}>
        <Column base={8} layout={12}>
          <span className={styles.accessHeaderFirstColumn}>Partner pages</span>
        </Column>
        <Column base={2} layout={12}>
          View
        </Column>
        <Column base={2} layout={12}>
          Edit
        </Column>
      </div>
    )
  }

  render() {
    const {
      ctaText,
      completeText,
      submittingText,
      title,
      dispatch,
      modals,
      description,
      metaData,
    } = this.props
    const schema = this._schema()
    const form = this.props.forms[this.props.id]
    const disable = (form && form._isPosting)
    const forceClose = (form && form._hasCompleted)
    const roleInfo = this.state.selectedRole

    return (
      <Modal
        className={styles.bg}
        disable={disable}
        dispatch={dispatch}
        forceClose={forceClose}
        id={this.props.id}
        modals={modals}
        onClose={this._hide}
      >
        <div className={styles.base}>
          <Heading className={styles.title} size="large">
            {title}
          </Heading>
          <p className={styles.content}>{description}</p>

          {this.state.showAlert &&
            <Alert type="info">
              The entered user already has an Administrator role assigned.<br />
              To continue either enter a new username or select &apos;Edit existing user&apos;
            </Alert>
          }

          {form &&
            <form
              className={styles.form}
              id={this.props.id}
              noValidate="novalidate"
              onSubmit={this._handleSubmit}
            >

              <fieldset>
                <ul>
                  <li>
                    <SelectInput
                      {...schema.userType}
                      searchable
                      error={form.userType.error}
                      handleChange={this._handleSelectChange}
                      onBlur={this._handleValidation}
                      valid={form.userType.valid}
                      value={form.userType.value}
                    />
                  </li>
                  {form.userType.value &&
                    <li>
                      <AutoCompleteInput
                        {...schema.username}
                        hasFetching
                        error={form.username.error}
                        fetched={metaData.fetched}
                        fetching={metaData.isFetching}
                        focus={form.username.focus}
                        handleChange={this._handleSuggestion}
                        handleChangeAfterClick={this._handleAfterClick}
                        minQueryLength={3}
                        onBlur={this._handleValidation}
                        onFocus={this._handleFocus}
                        suggestions={this.getSuggetionList()}
                        valid={form.username.valid}
                        value={form.username.value.label || form.username.value}
                      />
                    </li>
                  }
                </ul>
                {this.state.showStatusAndRole &&
                  <ul>
                    <li>
                      <SelectInput
                        {...schema.status}
                        searchable
                        error={form.status.error}
                        handleChange={this._handleSelectChange}
                        onBlur={this._handleValidation}
                        valid={form.status.valid}
                        value={form.status.value}
                      />
                    </li>
                    <li>
                      <SelectInput
                        {...schema.role}
                        error={form.role.error}
                        handleChange={this._handleSelectChange}
                        onBlur={this._handleValidation}
                        options={this.getRoleList()}
                        searchable
                        valid={form.role.valid}
                        value={form.role.value}
                      />
                      {form.role.value &&
                        <div>
                          <Card noPadding className={styles.access}>
                            <div className={styles.accessDesc}>{roleInfo.description}</div>
                            <div className={styles.accessDetails}>
                              <Row>
                                <Column base={6} className={styles.firstColumn} layout={12}>
                                  <Row>
                                    {this.renderAdminCentreAccessHeader()}
                                    {
                                      roleInfo.adminCenterAccess.map((access) => {
                                        return this.renderAdminCentreAccess(access.functionAreaDisplayName, access.hasAccess !== null)
                                      })
                                    }
                                  </Row>
                                </Column>
                                <Column base={6} className={styles.secondColumn} layout={12}>
                                  <Row>
                                    {this.renderPartnerPagesAccessHeader()}
                                    {
                                      roleInfo.partnerPagesAccess.map((access) => {
                                        return access.hasAccess === null ?
                                          this.renderPartnerPagesAccess(
                                            access.functionAreaDisplayName,
                                            false,
                                            false,
                                          ) :
                                          this.renderPartnerPagesAccess(
                                            access.functionAreaDisplayName,
                                            access.hasAccess.includes('R'),
                                            access.hasAccess.includes('W'),
                                          )
                                      })
                                    }
                                  </Row>
                                </Column>
                              </Row>
                            </div>
                          </Card>
                        </div>}
                    </li>
                  </ul>
                }

              </fieldset>
              <br /><br />
              <div className={styles.footer}>
                <SubmitButton
                  complete={this.props.forms[this.props.id]._isComplete}
                  completeText={completeText} // Add validation rules
                  disabled={!this.canSubmit()}
                  isLarge
                  submitting={this.props.forms[this.props.id]._isPosting}
                  submittingText={submittingText}
                >
                  {ctaText}
                </SubmitButton>
              </div>
            </form>
          }
        </div>
      </Modal>
    )
  }
}
export default ManagePermissionsView



// WEBPACK FOOTER //
// ./src/views/ManagePermissions/ManagePermissions.js